import React, { useRef, useEffect } from 'react';

/**
 * Two-row series navigation component for shorts
 * Row 1: Event name corresponding to selected Lecture Series ID (red background)
 * Row 2: Lecture Series IDs (scrollable)
 */
const ShortsNavigation = ({ series, currentSeries, shorts, onSeriesChange }) => {
  const scrollRef = useRef(null);

  // Scroll selected series into view
  useEffect(() => {
    if (scrollRef.current && currentSeries !== 'all') {
      const selectedElement = scrollRef.current.querySelector(`[data-series="${currentSeries}"]`);
      if (selectedElement) {
        selectedElement.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'nearest', 
          inline: 'center' 
        });
      }
    }
  }, [currentSeries]);

  // Abbreviate series names for the second row
  const abbreviateSeries = (name) => {
    if (!name || name === 'all') return name;
    if (name.length > 20) {
      return name.substring(0, 17) + '...';
    }
    return name;
  };

  // Get the selected series display name
  // If 'all' is selected, show "All Channel Short Videos"
  // Otherwise find the Event name for the selected Lecture Series ID
  let selectedSeriesName = 'All Channel Short Videos';
  
  if (currentSeries !== 'all') {
    // Find a short with this Lecture Series ID to get its Event name
    const shortWithThisSeries = shorts.find(short => short.series === currentSeries);
    selectedSeriesName = shortWithThisSeries?.eventName || currentSeries;
  }

  // Filter out the currently selected series from the second row
  const otherSeries = series.filter(s => s !== currentSeries);

  return (
    <div className="shorts-navigation">
      {/* Row 1: Selected Series */}
      <div className="shorts-nav-selected">
        <div className="selected-series">
          <span className="series-name">{selectedSeriesName}</span>
          <span className="checkmark">✓</span>
        </div>
      </div>

      {/* Row 2: Other Series (scrollable) */}
      <div className="shorts-nav-other" ref={scrollRef}>
        {/* Always show "All" option first if not currently selected */}
        {currentSeries !== 'all' && (
          <button 
            className="series-option"
            onClick={() => onSeriesChange('all')}
            data-series="all"
          >
            All
          </button>
        )}
        
        {/* Show other series */}
        {otherSeries.map((seriesName) => (
          <button
            key={seriesName}
            className="series-option"
            onClick={() => onSeriesChange(seriesName)}
            data-series={seriesName}
          >
            {abbreviateSeries(seriesName)}
          </button>
        ))}
        
        {/* Scroll indicator if there are more series */}
        {otherSeries.length > 3 && (
          <div className="scroll-indicator">
            <span>›</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShortsNavigation;